// Neu (SPEC 03 §7.1 `/unbekannt`) — derselbe Satz wie die 404 der API (02 §1.7): es verrät
// nicht, OB es den Verweis gibt, nur dass man ihn hier nicht öffnen kann.
import { useNavigate, useSearchParams } from "react-router-dom";
import { Btn, Icon } from "../components/ui";
import { useTitel } from "../hooks/useTitel";
import { TX } from "../lib/texte";
import { useStore } from "../store/useStore";

export function Unbekannt() {
  useTitel("Unbekannt");
  const [such] = useSearchParams();
  const ref = such.get("ref");
  const V = useStore((s) => s.verfahren);
  const navigate = useNavigate();
  return (
    <section className="card hinweisseite karte-ein" aria-labelledby="unbekannt-titel">
      <span className="marke-kachel" style={{ width: 44, height: 44, borderRadius: 12, margin: "0 auto" }} aria-hidden="true">
        <Icon name="magnifying-glass" size={22} />
      </span>
      <h1 id="unbekannt-titel">{TX.fehler.unbekannt}</h1>
      {ref && (
        <span className="ref" translate="no">
          {ref}
        </span>
      )}
      <div className="reihe wrap" style={{ justifyContent: "center", marginTop: 22 }}>
        <Btn type="button" icon="chart-bar" onClick={() => navigate(V ? `/v/${encodeURIComponent(V)}/auswerten` : "/", { replace: true })}>
          {TX.fehler.zurAuswertung}
        </Btn>
      </div>
    </section>
  );
}

export default Unbekannt;
